import type { PistaCena } from '../../dominio/didatico/pistasCena'

interface Props {
  pista: PistaCena
  aoFechar: () => void
}

/**
 * Card didático detalhado exibido ao selecionar uma pista de cena / marcador de trauma 3D (Fase 2).
 */
export function CardPistaCena({ pista, aoFechar }: Props) {
  return (
    <div className="card-pista-evidencia">
      <div className="cabecalho-pista">
        <div className="titulos-pista">
          <span className={`tag-categoria-pista tag-${pista.categoria}`}>
            {pista.categoria.toUpperCase()}
          </span>
          <h4>{pista.titulo}</h4>
          <span className="subtitulo-pista">{pista.subtitulo}</span>
        </div>
        <button
          type="button"
          className="btn-fechar-pista"
          onClick={aoFechar}
          title="Fechar inspeção da evidência"
        >
          ×
        </button>
      </div>

      <div className="corpo-pista">
        <p className="descricao-achado">
          <strong>Achado Pericial:</strong> {pista.descricao}
        </p>

        <p className="mecanismo-achado">
          <strong>Mecanismo Biomecânico:</strong> {pista.mecanismo}
        </p>

        <div className="secao-suspeitas-phtls">
          <strong>Suspeitas Clínicas Prioritárias (PHTLS):</strong>
          <ul>
            {pista.suspeitasPhtls.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="conduta-aph-destaque">
          <strong>Diretriz CBMMG / APH:</strong>
          <p>{pista.condutaCbmmg}</p>
        </div>
      </div>
    </div>
  )
}
